<template>
  <header class="container-wide">
    <div class="logo">
      <router-link to="/shield">
        <img src="../assets/shield-logo-web_1.svg" alt="shield maintenance" />
      </router-link>
      <router-view />
    </div>
    <div class="container-inner">
      <nav class="shield-top-header">
        <ul class="shield-qualities">
          <li>prompt</li>
          <li>professional</li>
          <li>prepared</li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "ShieldHeader"
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

.shield-home {
  position: relative;
  .logo {
    @media screen and (max-width: $medium-bp) {
      width: 70%;
      margin: auto;
    }

    @media screen and (min-width: $medium-bp+0.1) {
      position: relative;
      left: 70%;
      width: 25%;
      margin-top: 1em;
      margin-right: 5%;
    }
  }

  .shield-top-header {
    position: relative;
    @media screen and (min-width: $medium-bp+0.1) {
      width: 20%;
      left: 77%;
    }
  }

  .shield-qualities {
    list-style: none;
    @media screen and (max-width: $medium-bp) {
      display: flex;
      justify-content: center;
      font-size: 0.8em;
    }

    @media screen and (min-width: $medium-bp+0.1) {
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      border-left: 1px solid #000;
    }
  }
}

.shield-qualities > li {
  @media screen and (max-width: $medium-bp) {
    margin-left: 1em;
    margin-right: 1em;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    margin-right: 1em;
  }
}
</style>
